import { AxiosInstance, AxiosRequestConfig } from 'axios';
import RpcMethod from './rpcMethod';
import { getRpcParams } from './rpcUtils';

export interface IGetPricingResponse {
  monthly: number;
  annually: number;
  discount: number;
}
export interface ISubscriptionPlanPrice extends IGetPricingResponse {
  productHandle: string;
}

export interface IMigratePlanParams {
  productHandle: string;
  subscriptionType: 'annually' | 'monthly';
  userCount?: number;
  couponCode?: string;
  trial?: boolean;
}

export default function createSubscriptionRpcService(client: AxiosInstance) {
  return {
    startTrial: (config?: AxiosRequestConfig) =>
      client.post<IRestApiRpcEnvelope<{ product_handle: string }>>(
        '/rpc/subscription',
        getRpcParams(RpcMethod.MIGRATE_PLAN, {
          product_handle: 'pro-monthly',
          subscription_type: 'monthly',
          trial: true,
        }),
        config
      ),
    migratePlan: (params: IMigratePlanParams, config?: AxiosRequestConfig) =>
      client.post<IRestApiRpcEnvelope<{ product_handle: string }>>(
        '/rpc/subscription',
        getRpcParams(RpcMethod.MIGRATE_PLAN, {
          product_handle: params.productHandle,
          subscription_type: params.subscriptionType,
          user_count: params.userCount ?? 0,
          coupon_code: params.couponCode,
          trial: params.trial ?? false,
        }),
        config
      ),
    cancelAnnualSubscription: (config?: AxiosRequestConfig) =>
      client.post('/rpc/subscription', getRpcParams(RpcMethod.CANCEL_ANNUAL_SUBSCRIPTION, {}), config),
    getPrices: (config?: AxiosRequestConfig) =>
      client.post<IRestApiRpcEnvelope<ISubscriptionPlanPrice[]>>(
        '/rpc/subscription',
        getRpcParams(RpcMethod.GET_PRICES, {}),
        config
      ),
    downgrade: (config?: AxiosRequestConfig) =>
      client.post('/rpc/subscription', getRpcParams(RpcMethod.DOWNGRADE, {}), config),
    setCreditCardWithPaymentMethod: (paymentMethodId: string, config?: AxiosRequestConfig) =>
      client.post(
        '/rpc/subscription',
        getRpcParams(RpcMethod.SET_CREDIT_CARD_WITH_PAYMENT_METHOD, { paymentMethodId: paymentMethodId }),
        config
      ),
    createSetupIntent: (config?: AxiosRequestConfig) =>
      client.post<IRestApiRpcEnvelope<ICreateSetupIntentResponse>>(
        '/rpc/subscription',
        getRpcParams(RpcMethod.CREATE_SETUP_INTENT, {}),
        config
      ),
  };
}

export interface ICreateSetupIntentResponse {
  clientSecret: string;
}

export interface IRestApiRpcEnvelope<T> {
  jsonrpc: string;
  id: string;
  result: T;
}
